// Shared across this directory
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';
import { AuthHeader, Icon } from '../../components';
import { theme, toRem } from '../../design';

export const Layout = styled.div`
  flex-flow: column;
  justify-content: center;
  padding: 0 30px;
  text-align: center;
  align-items: center;
  flex-grow: 1;
  max-width: ${toRem(520)};
  gap: ${toRem(44)};

  header {
    background: inherit;
  }
`;

export const StyledAuthHeader = styled(AuthHeader)`
  h1 {
    font-size: ${toRem(28)};
  }
  p {
    font-size: ${toRem(14)};
  }
`;

export const ContentContainer = styled.div`
  flex-flow: column;
  width: 100%;
  background: ${theme.color.neutral[100]};
  padding: ${toRem(24)};
  border: ${toRem(1)} solid ${theme.color.neutral[200]};
  border-radius: ${toRem(8)};
  gap: ${toRem(8)};
  text-align: start;
`;

const SkeletonContainer = styled.div`
  width: 100%;
  flex-flow: column;
  gap: ${toRem(10)};
`;

export const LoadingHeader = () => (
  <SkeletonContainer>
    <Skeleton width={100} height={45} />
    <Skeleton width={400} height={36} />
    <Skeleton count={3} />
  </SkeletonContainer>
);

const AccessDeniedIconContainer = styled.div`
  border-radius: 50%;
  height: ${toRem(88)};
  width: ${toRem(88)};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.color.warning.light};
  margin-bottom: ${toRem(24)};

  svg {
    fill: ${theme.color.warning.medium};
    height: ${toRem(55)};
    width: ${toRem(55)};
  }
`;

export const AccessDeniedIcon = () => (
  <AccessDeniedIconContainer>
    <Icon icon="Caution" />
  </AccessDeniedIconContainer>
);
